<script lang="ts">
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"
  import type { OrganizationUser } from "@kontextwerk/control-web-client"
  import type { UserCreateExtensionStepContext } from "@kontextwerk/control-web-frame"
  import UserWorkingHoursEditor from "../../../../../../_shared/_modules/user-working-hours-editor"

  const { ctx }: { ctx: UserCreateExtensionStepContext } = $props()

  let updatedUser = $state<OrganizationUser | null>(null)
  const targetUser = $derived(updatedUser?.id === ctx.user.id ? updatedUser : ctx.user)

  const handleUpdated = (updated: OrganizationUser) => {
    updatedUser = updated
    ctx.onUserUpdated(updated)
  }
</script>

<div class="invite-working-hours">
  {#key targetUser.id}
    <UserWorkingHoursEditor
      user={targetUser}
      organizationId={ctx.organizationId}
      surfaceTone="dark"
      onUpdated={handleUpdated}
    />
  {/key}

  <div class="step-actions">
    <CTA type="ghostButton" content="Zurück" onClick={ctx.requestPrevious} darkMode={true} />
    <CTA type="primaryButton" content="Fertig" onClick={() => ctx.requestComplete(targetUser)} />
  </div>
</div>

<style lang="less">
  .invite-working-hours {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .step-actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.8rem;
    flex-wrap: wrap;
  }
</style>
